module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "back-link-spaced",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.name || 'Voltar'))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1051a98!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/back_link.vue
// module id = 1208
// module chunks = 1